import React from 'react';
import Select, { NonceProvider } from "react-select";

export * from 'react-select';

export default class NoncedSelect extends React.Component {
  render() {
    const cspNonce = document.querySelector("meta[name=csp-nonce]")?.content;

    return (
      <NonceProvider cacheKey="react-select-style-cache" nonce={cspNonce}>
        <Select {...this.props}>
          {this.children}
        </Select>
      </NonceProvider>
    );
  }
}

NoncedSelect.propTypes = Select.propTypes;